import { ThemeOptions } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import { ptBR } from '@mui/material/locale'

const theme: ThemeOptions = {
  palette: {
    primary: { main: '#185CFB', dark: '#00638C', light: '#DCF5FF' },
    secondary: { main: '#333333', light: '#666' },
    error: { main: '#DB082C', dark: '#DB082C', light: '#FEA6A6' },
    success: { main: '#417505', light: '#C3E39E' },
    warning: { main: '#F5A623' },
    black: { main: '#333333', contrastText: '#FFF' },
    primaryDark: { main: '#00638C', contrastText: '#FFF' },
    purple: { main: '#6755AF', contrastText: '#FFF' },
    background: {
      default: 'var(--background-primary)',
      paper: 'var(--surface-neutral-primary)',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    allVariants: {
      fontFamily: 'var(--font-family-sans)',
    },
    fontFamily: 'var(--font-family-sans)',
    body1: {
      fontSize: 'var(--font-size-100)',
      lineHeight: 'var(--font-line-height-150)',
      color: 'var(--color-fill-primary)',
    },
    body2: {
      fontSize: 'var(--font-size-087)',
      lineHeight: 'var(--font-line-height-150)',
      color: 'var(--color-fill-primary)',
    },
    caption: {
      fontSize: 'var(--font-size-075)',
      lineHeight: 'var(--font-line-height-125)',
      color: 'var(--color-fill-tertiary)',
    },
    h1: {
      fontFamily: 'var(--font-family-sans)',
      fontWeight: 'var(--font-weight-semibold)',
      fontSize: 'var(--font-size-150)',
      lineHeight: 'var(--font-line-height-175)',
      color: 'var(--color-fill-primary)',
    },
    h2: {
      fontFamily: 'var(--font-family-display-01)',
      fontWeight: 'var(--font-weight-regular)',
      fontSize: 'var(--font-size-425)',
      lineHeight: 'var(--font-line-height-425)',
      color: 'var(--color-fill-primary)',
    },
    h3: {
      fontFamily: 'var(--font-family-display-01)',
      fontWeight: 'var(--font-weight-regular)',
      fontSize: 'var(--font-size-350)',
      lineHeight: 'var(--font-line-height-350)',
      color: 'var(--color-fill-primary)',
    },
    h4: {
      fontFamily: 'var(--font-family-display-01)',
      fontWeight: 'var(--font-weight-regular)',
      fontSize: 'var(--font-size-300)',
      lineHeight: 'var(--font-line-height-300)',
      color: 'var(--color-fill-primary)',
    },
    h5: {
      fontFamily: 'var(--font-family-sans)',
      fontWeight: 'var(--font-weight-semibold)',
      fontSize: 'var(--font-size-125)',
      lineHeight: 'var(--font-line-height-150)',
      color: 'var(--color-fill-primary)',
    },
    h6: {
      fontFamily: 'var(--font-family-sans)',
      fontWeight: 'var(--font-weight-semibold)',
      fontSize: 'var(--font-size-100)',
      lineHeight: 'var(--font-line-height-125)',
      color: 'var(--color-fill-primary)',
    },
    subtitle1: {
      fontFamily: 'var(--font-family-sans)',
      fontWeight: 'var(--font-weight-semibold)',
      fontSize: 'var(--font-size-150)',
      lineHeight: 'var(--font-line-height-175)',
      color: 'var(--color-fill-primary)',
    },
  },
}

export default createTheme(theme, ptBR)
